import { connect } from "react-redux";
import { toggleBookingCancelModal } from "../../../redux/timeslots/actions";
import { cancelAppointmentBooking } from "../../../redux/reservations/actions";
import { toggleDonorSettingsModal } from "../../../redux/users/actions";
import CancelBooking from "./CancelBooking";

const mapStateToProps = (state) => ({
  bloodbankId: state.authReducer.currentBloodbank,
  bloodbankName: state.authReducer.bloodbankName,
  selectedTimeslot: state.timeslotsReducer.selectedTimeslot,
  donorDetailsData: state.usersReducer.donorDetailsData,
  bookingCancelModalIsOpen: state.timeslotsReducer.bookingCancelModalIsOpen,
  donorSettingsModalIsOpen: state.usersReducer.donorSettingsModalIsOpen,
});

const mapDispatchToProps = {
  toggleBookingCancelModal,
  cancelAppointmentBooking,
  toggleDonorSettingsModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(CancelBooking);
